<template>
  <div :class="classname">
    <label class="form-check form-switch form-check-custom form-check-solid">
      <input class="form-check-input" type="checkbox"
             :name="name"
             :id="`input-${name}`"
             :disabled="disable"
             :checked="modelValue"
             @change="$emit('update:modelValue', $event.target.checked)"
             :required="required">
      <span class="form-check-label">{{ $t(label) }}</span>
    </label>
  </div>
</template>

<script setup>
/* eslint-disable */
const props = defineProps( {
  name: String,
  modelValue: String,
  classname: {type: String, default: "mb-10"},
  required: {type:Boolean, default: true},
  label: String,
  disable: {type:Boolean, default: false},
})



</script>
<style scoped>
input.invalid {
  border: 1px solid red;
}
</style>